// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://eqgopcqmcjyqliwhmsbf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVxZ29wY3FtY2p5cWxpd2htc2JmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwNDUyNDMsImV4cCI6MjA2NjYyMTI0M30.5VxkZbb9qBbVTvQf1cgfr8LDUEjPi9ho-s28fEfOoJQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Public client for unauthenticated access (e.g., public share pages)
// This client never sends Authorization headers, avoiding 401 errors from stale sessions
export const supabasePublic = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
    storage: undefined,
  }
});